import React, { forwardRef } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, LabelList } from "recharts";
import { SectionCard, ChartTooltip, fmtNum, C, axisTick } from "../shared";

// smaller labels for the grouped (4-per-year) bars so they don't collide
const qLabel = { fill: "#cbd0d8", fontSize: 9, fontWeight: 600 };

const EpsSection = forwardRef(({ quarterly }, ref) => (
  <SectionCard ref={ref} id="eps" icon="eps" title="Quarterly EPS">
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={quarterly} margin={{ top: 18, right: 8, left: 0, bottom: 0 }} barCategoryGap="28%">
        <CartesianGrid strokeDasharray="3 3" stroke={C.grid} vertical={false} />
        <XAxis dataKey="year" tick={axisTick} tickLine={false} axisLine={{ stroke: C.border }} />
        <YAxis tick={axisTick} tickLine={false} axisLine={false} width={38} />
        <Tooltip content={<ChartTooltip />} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
        <Legend wrapperStyle={{ fontSize: 12, color: C.muted }} />
        <Bar dataKey="Q1" name="Q1" fill={C.blue}    radius={[3, 3, 0, 0]} maxBarSize={13} isAnimationActive={false}>
          <LabelList dataKey="Q1" position="top" style={qLabel} formatter={(v) => fmtNum(v)} />
        </Bar>
        <Bar dataKey="Q2" name="Q2" fill="#a78bfa"   radius={[3, 3, 0, 0]} maxBarSize={13} isAnimationActive={false}>
          <LabelList dataKey="Q2" position="top" style={qLabel} formatter={(v) => fmtNum(v)} />
        </Bar>
        <Bar dataKey="Q3" name="Q3" fill={C.green}   radius={[3, 3, 0, 0]} maxBarSize={13} isAnimationActive={false}>
          <LabelList dataKey="Q3" position="top" style={qLabel} formatter={(v) => fmtNum(v)} />
        </Bar>
        <Bar dataKey="Q4" name="Q4" fill={C.orange}  radius={[3, 3, 0, 0]} maxBarSize={13} isAnimationActive={false}>
          <LabelList dataKey="Q4" position="top" style={qLabel} formatter={(v) => fmtNum(v)} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </SectionCard>
));

export default EpsSection;
